import { render } from "./check_post.vue?vue&type=template&id=0c12819f"
import script from "./check_post.vue?vue&type=script&lang=js"
export * from "./check_post.vue?vue&type=script&lang=js"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__